import { AppStatus } from '../../core/constants/AppStatus';

export function getDefaultVendorStatusSelection() {
  return new Set<string>([
    AppStatus.PENDING,
    AppStatus.APPROVED,
    AppStatus.ACTIVE,
    AppStatus.WAITLISTED,
  ]);
}
